import type { MetricsRow } from 'app/services/metrics'
import type React from 'react'
import { ColumnDef } from '@tanstack/react-table'
import { PageScroll } from 'app/components/layout/PageScroll'
import { PageHeader } from 'app/components/ui/page-header'
import SimpleTable from 'app/components/table/SimpleTable'
import { FilterableColumn } from 'app/filter.utils'

export type CompaniesLocationsShadcnComponentProps = {
  filteredRows: MetricsRow[] | undefined
  columns: ColumnDef<MetricsRow, any>[]
  filterableColumns: FilterableColumn[]
  searchValue: string | undefined
  onSearchValueChange: (val: string | undefined) => void
  isDetailsOpen: boolean
  onDetailsClose: () => void
  locationTotals: MetricsRow[] | undefined
  detailColumns: ColumnDef<MetricsRow, any>[]
  totalItems: number | undefined
  loadAllLocations: () => Promise<void>
  scrollHandler: React.UIEventHandler<HTMLDivElement>
}

export function CompaniesLocationsShadcnComponent({
  filteredRows,
  columns,
  filterableColumns,
  onSearchValueChange,
  isDetailsOpen,
  onDetailsClose,
  locationTotals,
  detailColumns,
  totalItems,
  loadAllLocations,
  scrollHandler,
}: CompaniesLocationsShadcnComponentProps) {
  return (
    <>
      <PageScroll variant="table" header={<PageHeader totalItems={totalItems} title="Locations" />}>
        <SimpleTable
          data={filteredRows}
          columns={columns}
          showColumnOrdering={true}
          filterableColumns={filterableColumns}
          onSearchValueChange={(val) => onSearchValueChange(val)}
          onScroll={scrollHandler}
          enableExport
          onExport={loadAllLocations}
          edgePadded
        />
      </PageScroll>
      {isDetailsOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-overlay/50" onClick={onDetailsClose}>
          <div
            className="relative flex h-[80vh] w-[80vw] flex-col overflow-hidden rounded-lg bg-surface-raised shadow-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between border-b px-6 py-4">
              <h2 className="text-lg font-semibold">All locations</h2>
              <button className="text-muted-foreground hover:text-foreground" onClick={onDetailsClose}>
                ✕
              </button>
            </div>
            <div className="relative flex h-full max-h-full w-full flex-col overflow-hidden pt-4">
              <SimpleTable data={locationTotals} columns={detailColumns} showColumnOrdering={true} />
            </div>
          </div>
        </div>
      )}
    </>
  )
}
